<template>

    <div>

        <div class="checkout mb-4 mt-4">
            <div class="container">
                <div class="row pb-4">
                    <div class="col-lg-12">
                        <h5 class="checkout-title text-center mb-4" style="font-size: 2rem">
                            Compila il form se hai bisogno di assistenza
                        </h5>
                        <!-- End .checkout-title -->

                        <div class="card border">



                            <form @submit.prevent="sendOpenTicket" class="mt-2">
                                <div class="card-body pl-5 pr-5">
                                    <div>
                                        <label for="fullname" class="text-center mb-1">Nome e cognome <span
                                                class="text-danger">*</span></label>
                                        <input id="fullname" type="text" class="form-control" name="name"
                                            v-model="form.name" placeholder="Inserisci nome e cognome" autofocus />

                                        <div class="alert alert-danger" v-if="errors.name">
                                            {{ errors.name[0] }}
                                        </div>
                                    </div>
                                    <div>
                                        <label for="email" class="text-center mb-1">E-Mail <span
                                                class="text-danger">*</span></label>
                                        <input id="email" type="email" class="form-control" name="email"
                                            v-model="form.email" placeholder="Inserisci la tua email" />

                                        <div class="alert alert-danger" v-if="errors.email">
                                            {{ errors.email[0] }}
                                        </div>
                                    </div>
                                    <div>
                                        <label for="phone" class="text-center mb-1">Telefono <span
                                                class="text-danger">*</span></label>
                                        <input id="phone" type="tel" class="form-control" name="phone"
                                            v-model="form.phone" placeholder="Inserisci il tuo numero di telefono" />

                                        <div class="alert alert-danger" v-if="errors.phone">
                                            {{ errors.phone[0] }}
                                        </div>
                                    </div>
                                    <div>
                                        <label for="message" class="text-center mb-1">Messaggio <span
                                                class="text-danger">*</span></label>
                                        <textarea name="message" id="message" class="form-control"
                                            v-model="form.message"></textarea>


                                        <div class="alert alert-danger" v-if="errors.message">
                                            {{ errors.message[0] }}
                                        </div>
                                    </div>

                                    <div class="float-right mb-2 mt-2">
                                        <button type="submit" class="btn btn-primary">Invia la richiesta di
                                            assistenza</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { useAuth } from "@/stores/auth.js";
import http from "@/services/http.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
    name: "AssistenzaPage",
    data() {
        return {
            form: {
                name: "",
                email: "",
                phone: "",
                message: ""
            },
            errors: [],
            successmessage: "",
        };
    },
    mounted() {
        const auth = useAuth();
        if (auth.token)
        {
            this.form.email = auth.user.email;
        }
    },
    methods: {
        async sendOpenTicket() {
            try
            {
                this.errors = [];

                const response = await http.post("/assistenza", this.form);

                this.successMessage = response.data.message;
                const $toast = useToast();
                $toast.open({
                    message: this.successMessage,
                    type: "info",
                    position: "top-right",
                    // all of other options may go here
                });
                // Reset del form senza riassegnare l'oggetto
                this.form.name = "";
                this.form.email = "";
                this.form.phone = "";
                this.form.message = "";
            } catch (error)
            {
                if (error.response?.data?.errors)
                {
                    this.errors = error.response.data.errors;
                } else
                {
                    console.error("Errore nella richiesta:", error);
                }
            }
        }

    }
}
</script>